import { MoreOptions } from "../models";

export const busOption: MoreOptions = {
    id: 'bus',
    label: 'routeForm.bus',
    iconSrc: 'assets/img/bus.svg',
}

export const bikeOption: MoreOptions = {
    id: 'bicycle',
    label: 'routeForm.bike',
    iconSrc: 'assets/img/bike.svg',
}

export const walkOption: MoreOptions = {
    id: 'walk',
    label: 'routeForm.walk',
    iconSrc: 'assets/img/walk.svg',
}

export const allOption: MoreOptions = {
    id: 'all',
    label: 'routeForm.all',
    iconSrc: 'assets/img/all.svg',
}


export const MORE_OPTIONS_SELECTOR: MoreOptions[] = [ busOption, walkOption, bikeOption, allOption]
